export default __webpack_public_path__ + "static/media/user.b4cc600d.jpg";